import { CreativeContext } from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative';
import { FormProvider, useForm } from 'react-hook-form';
import { Creative } from '@local-types';
import { xorBy } from 'lodash';
import { ModalSheetDialog as Dialog } from '../styledComponents';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
} from '@mui/material';
import { Button } from '@v2/components/ui/Button';
import { ManageTable } from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative/Manage/ManageTable';
import { ManageCreativesHeader } from './ManageCreativesHeader';
import { CancelButtonStyled } from '@v2/components/campaign/CampaignAdGroupSection/styles';
import { CommonDialogProps } from '@components/modals/BulkEditModal/constants/types';

export interface ManageCreativesProps extends CommonDialogProps {
  onSubmit: (data: ManageCreativesFormValues) => void;
  isDisplay: boolean;
  library: Creative[];
}

export interface ManageCreativesFormValues {
  draftCreatives: Creative[];
  weightingRotation: boolean;
}

export const ManageCreatives = ({
  onSubmit,
  onCancel,
  onBack,
  isValidating = false,
  open,
  isDisplay,
  library,
}: ManageCreativesProps) => {
  const methods = useForm<ManageCreativesFormValues>({
    defaultValues: {
      draftCreatives: library,
      weightingRotation: false,
    },
  });

  const {
    handleSubmit,
    formState: { isValid },
  } = methods;

  return (
    <CreativeContext.Provider
      value={{
        library,
        toggleAssignCreative: (creative: Creative) => {
          methods.setValue(
            'draftCreatives',
            xorBy(methods.getValues('draftCreatives'), [creative], 'id')
          );
        },
        setTab: () => {},
        tab: {
          key: 'creativeLibrary',
        },
        drop: () => {},
      }}
    >
      <FormProvider {...methods}>
        <Dialog
          open={open}
          onClose={onCancel}
          fullWidth
          maxWidth="lg"
          sx={{ pt: 2, pb: 2 }}
          data-testid="edit-dates-times-dialog"
        >
          <form id="bulk-edit-form" onSubmit={handleSubmit(onSubmit)}>
            <DialogTitle>
              <ManageCreativesHeader
                onSubmit={handleSubmit(onSubmit)}
                onBack={onBack}
                onCancel={onCancel}
                isDisplay={isDisplay}
              />
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ p: 3 }}>
              <ManageTable
                onSubmit={handleSubmit(onSubmit)}
                isDisplay={isDisplay}
              />
            </DialogContent>
            <DialogActions disableSpacing sx={{ px: 4, py: 3 }}>
              <Grid container direction="column" sx={{ width: '100%' }}>
                <Divider sx={{ width: '100%', mb: 3 }} />
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  sx={{ minHeight: 'auto' }}
                >
                  <Grid>
                    <CancelButtonStyled variant="text" onClick={onCancel}>
                      Cancel
                    </CancelButtonStyled>
                  </Grid>
                  <Grid>
                    <Button
                      variant="contained"
                      type="submit"
                      label="Next: Review Edits"
                      disabled={!isValid || isValidating}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        </Dialog>
      </FormProvider>
    </CreativeContext.Provider>
  );
};
